import {Command} from './Command';
import {TierStepSizeChangeAction} from '../actions/TierStepSizeChangeAction';
import {StageService} from '../../stage.service';

export class TierStepSizeChangeCommand extends Command<TierStepSizeChangeAction> {

  private action: TierStepSizeChangeAction;

  constructor(
    private stage: StageService
  ) {
    super();
  }

  do(action: TierStepSizeChangeAction): void {
    this.action = action;
  }

  undo(): void {
    const {tierCustomId, transformations, pointInfo} = this.action;
    const tier = this.stage.getChildrenByPredicate(child => child.userData.customId === tierCustomId)[0];
    const steps = tier.children.find(obj => obj.name === 'tierSteps');
    steps.children.forEach((child, index) => {
      const transformation = transformations[index];
      if (transformation) {
        child.position.copy(transformation.position);
        child.scale.copy(transformation.scale);
      }
    });
    const points = tier.userData.points;
    const lastPoint = points[points.length - 1];
    lastPoint.width = pointInfo.width;
    lastPoint.distance = pointInfo.distance;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/eventLog/commands/TierStepSizeChangeCommand.ts